export const firstNotUndefined = (...array) => {
  return array.find(item => item !== undefined)
}
